import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import BSL_Dialog from "../components/BSL_Dialog";
import BSL_TextInput from "../components/BSL_TextInput";
import BSL_ControlContainer from "../components/BSL_ControlContainer";
import * as BSL_Common from "../components/BSL_CommonControls";
import { Chip, IconButton } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import DoneIcon from "@material-ui/icons/Done";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import BSL_Select from "../components/BSL_Select";
import Autocomplete from "react-autocomplete";
import SegmentedButtonGroup from "../components/SegmentedButtonGroup";

export function ReplaceAll(target, search, replacement) {
    return target.replace(new RegExp(search, "g"), replacement);
}

export default function ManageProductListAncillary(props) {
    const { row, value, mode, offering_editcell, saveValue, onClose, pricefileDescSummary, embed, subhead, parent } =
        props;

    let ancillary_raw = row?.AncillaryParts ? row?.AncillaryParts : [];

    if (mode === "OFFERING" || mode === "FILTER") {
        ancillary_raw = value ? value : [];
    }

    const [displayData, setDisplayData] = React.useState(ancillary_raw);
    const [ancillaryData, setAncillaryData] = React.useState(undefined);
    const [newCode, setNewCode] = React.useState("");
    const [newConditionKey, setNewConditionKey] = React.useState("");
    const [newConditionOperator, setNewConditionOperator] = React.useState("=");
    const [newConditionValue, setNewConditionValue] = React.useState("");
    const [addNewCondition, setAddNewCondition] = React.useState(undefined);
    const [confirmDelete, setConfirmDelete] = React.useState(null);
    const [autocompleteOptions, setAutocompleteOptions] = React.useState(embed ? pricefileDescSummary : null);
    const [displayDataValidJSON, setDisplayDataValidJSON] = React.useState(true);
    const OuterComponent = embed ? React.Fragment : BSL_Dialog;
    const outerProps = embed
        ? {}
        : {
              title: title,
              open: true,
              button1Text: "Update",
              button1Click: () => saveData(),
              button2Text: "Cancel",
              button2Click: onClose,
              style: { maxWidth: "initial" },
              fullWidth: true,
              maxWidth: "xl",
          };

    const checkValidJSON = (str) => {
        try {
            JSON.parse(str);
        } catch (ex) {
            try {
                JSON.parse("[" + str + "]");
            } catch (e) {
                setDisplayDataValidJSON(false);
                return false;
            }
        }
        setDisplayDataValidJSON(true);
        return true;
    };

    const handleTextChange = (ancillary_raw) => {
        let ancillary_items = [];
        if (ancillary_raw.startsWith && ancillary_raw.startsWith("{")) {
            let ancillary_raw_json = JSON.parse(ancillary_raw);
            ancillary_items = ancillary_raw_json["AncillaryParts"];
        } else if (typeof ancillary_raw === "object") {
            ancillary_items = ancillary_raw;
        } else {
            let split = ancillary_raw.split(" ");
            for (let i = 0; i < split.length; i++) {
                var this_item = split[i];
                if (this_item !== "") {
                    if (this_item.includes("(") && !this_item.includes(")") && i < split.length) {
                        while (i <= split.length) {
                            i++;
                            let next_bit = split[i];
                            this_item += " " + next_bit;
                            if (next_bit.includes(")")) break;
                        }
                    }
                    var this_item_object = {};
                    this_item_object.Code = this_item;

                    if (this_item.includes("x")) {
                        let split = this_item.split("x");
                        let is_numbers = /^\d+$/.test(split[0]);

                        if (is_numbers) {
                            split.forEach((str, i) => {
                                // eslint-disable-line no-loop-func
                                if (i === 0) this_item_object.Qty = str;
                                else if (i === 1) this_item_object.Code = str;
                                else this_item_object.Code += "x" + str;
                            });

                            if (this_item_object.Code.includes("(")) {
                                this_item_object.Use = this_item_object.Code.split("(")[1]
                                    .replace("(", "")
                                    .replace(")", "");
                                this_item_object.Code = this_item_object.Code.split("(")[0];
                            }
                        }
                    }

                    ancillary_items.push(this_item_object);
                }
            }
        }
        setAncillaryData(ancillary_items);
    };

    const appendNewCondition = (index, condition_value = null) => {
        if (!condition_value && newConditionValue !== 0) condition_value = newConditionValue;

        if (!newConditionKey) {
            alert("Choose a condition parameter");
            return;
        }

        if (!condition_value && condition_value !== 0) {
            alert("Add a condition value to compare to");
            return;
        }

        let new_ancillaryData = [...ancillaryData];
        let conditions = new_ancillaryData?.[index]?.Conditions;

        // Ensure conditions is an object
        if (typeof conditions !== "object" || conditions === null) conditions = {};

        let value = newConditionOperator + condition_value;
        if (newConditionOperator.includes("val")) value = newConditionOperator.replace("val", condition_value);

        // Handle existing conditions
        if (conditions[newConditionKey] != null) {
            if (!Array.isArray(conditions[newConditionKey])) {
                // If the existing condition is not an array, convert it to an array
                conditions[newConditionKey] = [conditions[newConditionKey]];
            }
            // Append the new value to the array
            conditions[newConditionKey].push(value);
        } else {
            // If the condition key does not exist, add it directly

            conditions[newConditionKey] = value;
        }

        new_ancillaryData[index].Conditions = conditions;
        setAncillaryData(new_ancillaryData);
        setNewConditionKey("");
        setNewConditionOperator("");
        setNewConditionValue("");
        setAddNewCondition(undefined);
    };

    const deleteCondition = (index, key, expression, individual_expression) => {
        let new_ancillaryData = [...ancillaryData];

        if (Array.isArray(expression) && expression.length > 1) {
            // Check if Conditions is an array
            if (Array.isArray(new_ancillaryData[index].Conditions[key])) {
                // Filter out the individual_expression from the conditions array
                new_ancillaryData[index].Conditions[key] = new_ancillaryData[index].Conditions[key].filter(
                    (e) => e !== individual_expression
                );
            } else {
                console.error("Conditions is not an array.");
            }
        } else {
            // Delete the condition based on the key
            delete new_ancillaryData[index].Conditions[key];

            // If there are no more conditions left, delete the Conditions object
            if (Object.keys(new_ancillaryData[index].Conditions).length === 0) {
                delete new_ancillaryData[index].Conditions;
            }
        }

        setAncillaryData(new_ancillaryData);
    };

    const updateCondition = (index, condition_key, new_condition_key, operator_value, condition_value) => {
        let new_ancillaryData = [...ancillaryData];
        delete new_ancillaryData?.[index]?.Conditions[condition_key];

        let value = operator_value + condition_value;
        if (operator_value.includes("val")) value = operator_value.replace("val", condition_value);

        new_ancillaryData[index].Conditions[new_condition_key] = value;
        setAncillaryData(new_ancillaryData);
    };

    const updateAncillaryData = (index, parameter, value, parent = null) => {
        let new_ancillaryData = [...ancillaryData];

        if (index === -1) {
            if (value) new_ancillaryData.push(parent?.filterType ? {} : { Code: value });
            setNewCode("");
        } else {
            if ((value === null) | (value === "") && new_ancillaryData[index][parameter] !== undefined) {
                delete new_ancillaryData[index][parameter];
            } else if (value !== null && value !== "") {
                new_ancillaryData[index][parameter] = value;
            }
        }

        setAncillaryData(new_ancillaryData);
    };

    const handleDeleteRow = (index) => {
        let new_ancillaryData = ancillaryData
            .slice(0, index)
            .concat(ancillaryData.slice(index + 1, ancillaryData.length));
        setAncillaryData(new_ancillaryData);
    };

    const handleMoveUpRow = (index) => {
        if (index <= 0) return;
        let new_ancillaryData = [...ancillaryData];
        var item = new_ancillaryData.splice(index, 1)[0];
        new_ancillaryData.splice(index - 1, 0, item);
        setAncillaryData(new_ancillaryData);
    };

    const handleCopyRow = (index) => {
        let new_ancillaryData = [...ancillaryData];
        var new_item = JSON.parse(JSON.stringify(new_ancillaryData[index]));
        new_ancillaryData.splice(index, 0, new_item);
        setAncillaryData(new_ancillaryData);
    };

    React.useEffect(() => {
        setDisplayData(ReplaceAll(JSON.stringify(ancillaryData).substring(1).slice(0, -1), "},", "},\n"));

        if (mode === "FILTER") {
            saveValue(parent?.rowNum, "modify", ancillaryData);
        } else if (embed) {
            saveValue(
                parent?.rowNum,
                "ancillary",
                ReplaceAll(JSON.stringify(ancillaryData).substring(1).slice(0, -1), "},", "},\n")
            );
        }
    }, [ancillaryData]);

    React.useEffect(() => {
        let data = getData();
        if (data.AncillaryParts.length === 0) {
            updateAncillaryData(-1, parent?.filterType, parent?.item, parent);
        }
    }, [parent?.item]);

    if (ancillaryData === undefined) {
        let ancillary_items = [];
        if (ancillary_raw.startsWith && ancillary_raw.startsWith("{")) {
            let ancillary_raw_json = JSON.parse(ancillary_raw);
            ancillary_items = ancillary_raw_json["AncillaryParts"];
        } else if (typeof ancillary_raw === "object") {
            ancillary_items = ancillary_raw;
        } else {
            let split = ancillary_raw.split(" ");
            for (let i = 0; i < split.length; i++) {
                var this_item = split[i];
                if (this_item !== "") {
                    if (this_item.includes("(") && !this_item.includes(")") && i < split.length) {
                        while (i <= split.length) {
                            i++;
                            let next_bit = split[i];
                            this_item += " " + next_bit;
                            if (next_bit.includes(")")) break;
                        }
                    }
                    var this_item_object = {};
                    this_item_object.Code = this_item;

                    if (this_item.includes("x")) {
                        let split = this_item.split("x");
                        let is_numbers = /^\d+$/.test(split[0]);

                        if (is_numbers) {
                            split.forEach((str, i) => {
                                // eslint-disable-line no-loop-func
                                if (i === 0) this_item_object.Qty = str;
                                else if (i === 1) this_item_object.Code = str;
                                else this_item_object.Code += "x" + str;
                            });

                            if (this_item_object.Code.includes("(")) {
                                this_item_object.Use = this_item_object.Code.split("(")[1]
                                    .replace("(", "")
                                    .replace(")", "");
                                this_item_object.Code = this_item_object.Code.split("(")[0];
                            }
                        }
                    }

                    ancillary_items.push(this_item_object);
                }
            }
        }
        setAncillaryData(ancillary_items);
    }

    const getData = () => {
        let data = { AncillaryParts: ancillaryData };
        return data;
    };

    var confirmed = false;
    const saveData = () => {
        if (!confirmed && newConditionValue) {
            alert(
                "You have an unsaved new condition ... are you sure you would like to proceed? Click Update again to proceed..."
            );
            confirmed = true;
            return;
        }

        confirmed = false;
        let data = getData();

        if (mode === "OFFERING" || mode === "FILTER") {
            saveValue(offering_editcell?.POA, offering_editcell?.key_path, ancillaryData);
        } else {
            saveValue(row, "AncillaryParts", JSON.stringify(data));
        }
    };

    let ancillary_rows = [];

    if (!autocompleteOptions) {
        let options = [];
        for (let option in pricefileDescSummary) {
            options.push(option + " - " + pricefileDescSummary[option]);
        }
        setAutocompleteOptions(options);
    }

    const condition_key_options = [
        { Key: "Use", Display: "Parent Use" },
        { Key: "Colour", Display: "Parent Colour" },
        { Key: "Qty", Display: "Parent Qty" },
        { Key: "Length", Display: "Parent Length" },
        { Key: "Desc", Display: "Parent Description" },
        { Key: "DescAppend", Display: "Parent Appended Desc" },
        { Key: "Job.RoofType", Display: "House RoofType", Options: ["STEEL", "TILE"] },
        { Key: "Job.WindZone", Display: "Job WindZone", Options: ["CYCLONIC", "NOT CYCLONIC"] },
        {
            Key: "Area.DesignType",
            Display: "Area Design Type",
            Options: [
                { Key: "Flat Roof", Display: "FLAT" },
                { Key: "Gable Hip Roof", Display: "GABLE" },
                { Key: "Flat Deck", Display: "DECK" },
            ],
        },
        {
            Key: "Area.RafterBeam",
            Display: "Area Rafter Beam",
            Options: ["656510", "1086510", "1586510", "2086510", "FL10011", "FL15015", "FL20020"],
        },
        {
            Key: "Area.PurlinBeam",
            Display: "Area Purlin Beam",
            Options: ["656510", "1086510", "1586510", "2086510", "FL10011", "FL15015", "FL20020"],
        },
        {
            Key: "Area.FasciaBeam",
            Display: "Area Fascia Beam",
            Options: ["656510", "1086510", "1586510", "2086510", "FL10011", "FL15015", "FL20020"],
        },
        {
            Key: "Area.HipBeam",
            Display: "Area Hip Beam",
            Options: ["656510", "1086510", "1586510", "2086510", "FL10011", "FL15015", "FL20020"],
        },
        {
            Key: "Area.PostType",
            Display: "Area Post Type",
        },
        { Key: "Area.BeamColour", Display: "Area Beam Colour" },
        { Key: "Area.PostColour", Display: "Area Post Colour" },
        { Key: "Area.RoofSheet", Display: "Area RoofSheet Type" },
        { Key: "Brand", Display: "Brand", Options: ["Lysaght", "Fielders"] },
        {
            Key: "POP",
            Display: "Job POP",
            Options: ["LSB", "EMU", "NUN", "LAU", "GIL", "KEW", "MEN", "MAR", "GAW", "NOA", "CAM", "MIN", "WAN"],
        },
        {
            Key: "Area.HasDutchGable",
            Display: "Area Has Dutch Gable Ends",
            Options: [
                { Key: true, Display: "Yes" },
                { Key: false, Display: "No" },
            ],
        },
        {
            Key: "AnyArea.RoofSheet",
            Display: "Any Area Roofsheet",
        },
        {
            Key: "AnyArea.RoofSpan",
            Display: "Any Area Roof Spans",
            Options: ["No Foot Traffic", "Non-Trafficable", "Cyclonic"],
        },
    ];

    const autoCompleteMarginTop = embed ? "2px" : "-33px";
    const autoCompleteItemMarginTop = embed ? "2px" : "-21px";

    const operator_options = [
        { Key: "=", Display: "= Equals" },
        { Key: "!=", Display: "!= Not Equals" },
        { Key: ">=", Display: "> (Greater than)" },
        { Key: ">=", Display: ">= (Greater than or " },
        { Key: "<", Display: "< (Less than)" },
        { Key: "<=", Display: "< or =" },
        { Key: "=val*", Display: "Starts with" },
        { Key: "=*val", Display: "Ends with" },
        { Key: "=*val*", Display: "Contains" },
        { Key: "!=val*", Display: "!=val* (Does Not Start With)" },
        { Key: "!=*val", Display: "!=*val (Does Not End With)" },
        { Key: "!=*val*", Display: "!=*val* (Does Not Contain)" },
    ];

    const expressionHandler = (expression, passthrough) => {
        if (Array.isArray(expression)) {
            for (let individual_expression of expression) {
                passthrough(individual_expression);
            }
        } else {
            passthrough(expression);
        }
    };

    if (ancillaryData) {
        let row_i = 0;
        for (let ancillaryRow of ancillaryData) {
            let row_num = row_i;
            row_i++;
            let conditions_chips = [];

            const backgroundColor = embed
                ? parent?.rowNum % 2 === 0
                    ? row_num % 2 === 0
                        ? "#a8faf8"
                        : "#d9fcfb"
                    : row_num % 2 === 0
                    ? "#d4ff86"
                    : "#ecffc8"
                : row_num % 2 === 0
                ? ""
                : "#f4f1eb";

            if (ancillaryRow?.Conditions) {
                let first = true;
                let row_condition_i = 0;

                for (let condition_key in ancillaryRow?.Conditions) {
                    let row_condition_num = row_condition_i;
                    row_condition_i++;
                    let expression = ancillaryRow?.Conditions[condition_key];

                    expressionHandler(expression, (individual_expression) => {
                        let value = individual_expression;

                        let operator_value = "=";
                        if (typeof value === "string") {
                            value = value.trim();
                            if (value.startsWith("!=")) operator_value = "!=";
                            else if (value.startsWith("=")) operator_value = "=";
                            else if (value.startsWith("<>")) operator_value = "<>";
                            else if (value.startsWith(">=")) operator_value = ">=";
                            else if (value.startsWith("<=")) operator_value = "<=";
                            else if (value.startsWith(">")) operator_value = ">";
                            else if (value.startsWith("<")) operator_value = "<";

                            if (operator_value === "=") {
                                if (value.startsWith("=*") && value.endsWith("*")) operator_value = "=*val*";
                                else if (value.startsWith("=*")) operator_value = "=*val";
                                else if (value.endsWith("*")) operator_value = "=val*";
                            } else if (operator_value === "!=") {
                                if (value.startsWith("!=*") && value.endsWith("*")) operator_value = "!=*val*";
                                else if (value.startsWith("!=*")) operator_value = "!=*val";
                                else if (value.endsWith("*")) operator_value = "!=val*";
                            }

                            value = value
                                .replace("!=", "")
                                .replace("=", "")
                                .replace(">", "")
                                .replace("<", "")
                                .replace("*", "")
                                .replace("*", "");
                        }

                        conditions_chips.push(
                            <Chip
                                key={`main-${row_condition_num}`}
                                label={
                                    <BSL_Common.SectionRow
                                        style={{
                                            alignItems: "center",
                                        }}
                                    >
                                        <span
                                            style={{
                                                fontSize: "12px",
                                                width: "40px",
                                                textAlign: "end",
                                            }}
                                        >
                                            {first ? "" : "AND "}IF:
                                        </span>
                                        <BSL_Select
                                            value={condition_key}
                                            style={{ flex: "none", width: "180px" }}
                                            tight={true}
                                            items={
                                                condition_key_options.find((kvp) => kvp.Key === condition_key)
                                                    ? condition_key_options
                                                    : [
                                                          ...condition_key_options,
                                                          { Key: condition_key, Display: condition_key + "*" },
                                                      ]
                                            }
                                            onChange={(e) =>
                                                updateCondition(
                                                    row_num,
                                                    condition_key,
                                                    e.target.value,
                                                    operator_value,
                                                    value
                                                )
                                            }
                                        />
                                        <BSL_Select
                                            value={operator_value}
                                            style={{ flex: "none", width: "120px", fontSize: "80%" }}
                                            tight={true}
                                            items={operator_options}
                                            onChange={(e) =>
                                                updateCondition(
                                                    row_num,
                                                    condition_key,
                                                    condition_key,
                                                    e.target.value,
                                                    value
                                                )
                                            }
                                        />
                                        {condition_key_options.find((kvp) => kvp.Key === condition_key)?.Options ? (
                                            <SegmentedButtonGroup
                                                style={{ width: "300px", flex: "none" }}
                                                value={value}
                                                tight={true}
                                                items={
                                                    condition_key_options.find((kvp) => kvp.Key === condition_key)
                                                        ?.Options
                                                }
                                                onChange={(e, val) => {
                                                    updateCondition(
                                                        row_num,
                                                        condition_key,
                                                        condition_key,
                                                        operator_value,
                                                        val
                                                    );
                                                    e.stopPropagation();
                                                }}
                                            />
                                        ) : (
                                            <BSL_TextInput
                                                value={value}
                                                placeholder="condition value"
                                                tight
                                                style={{ flex: "none", width: "160px" }}
                                                onEnter={(e) =>
                                                    updateCondition(
                                                        row_num,
                                                        condition_key,
                                                        condition_key,
                                                        operator_value,
                                                        e.target.value
                                                    )
                                                }
                                                InputProps={{
                                                    style: { fontSize: "80%" },
                                                }}
                                                onBlur={(val) =>
                                                    updateCondition(
                                                        row_num,
                                                        condition_key,
                                                        condition_key,
                                                        operator_value,
                                                        val
                                                    )
                                                }
                                                onChange={(val) => {
                                                    if (val)
                                                        updateCondition(
                                                            row_num,
                                                            condition_key,
                                                            condition_key,
                                                            operator_value,
                                                            val
                                                        );
                                                }}
                                            />
                                        )}
                                    </BSL_Common.SectionRow>
                                }
                                style={{ width: "fit-content", height: "auto", marginTop: "5px" }}
                                onDelete={() => {
                                    deleteCondition(row_num, condition_key, expression, individual_expression);
                                }}
                            />
                        );
                        first = false;
                    });
                }
            }

            ancillary_rows.push(
                <BSL_Common.SectionRow
                    key={`ancillary-${row_num}`}
                    style={{
                        backgroundColor: backgroundColor,
                    }}
                >
                    {(!parent?.operation || parent?.operation !== "delete") && (
                        <React.Fragment>
                            {row_num === 0 && subhead && (
                                <BSL_Common.SectionRow>
                                    <div
                                        style={{
                                            fontSize: "13px",
                                            fontFamily: "'canada-type-gibson', sans-serif",
                                            fontWeight: "200",
                                            padding: "2px 0px 0px 2px",
                                        }}
                                    >
                                        {subhead}
                                    </div>
                                </BSL_Common.SectionRow>
                            )}
                            <BSL_Common.SectionColumn
                                style={{
                                    width: "32px",
                                    height: "100%",
                                    paddingTop: row_num === 0 ? "32px" : "8px",
                                    flex: "none",
                                }}
                            >
                                {!embed && row_num > 0 && (
                                    <IconButton
                                        aria-label="move up"
                                        size="small"
                                        onClick={() => {
                                            handleMoveUpRow(row_num);
                                        }}
                                    >
                                        <ArrowDropUpIcon fontSize="inherit" />
                                    </IconButton>
                                )}
                                <IconButton
                                    aria-label="delete"
                                    size="small"
                                    onClick={() => {
                                        setConfirmDelete(row_num);
                                    }}
                                >
                                    <DeleteIcon fontSize="inherit" />
                                </IconButton>
                                {!embed && (
                                    <IconButton
                                        aria-label="copy"
                                        size="small"
                                        onClick={() => {
                                            handleCopyRow(row_num);
                                        }}
                                    >
                                        <FileCopyIcon fontSize="inherit" />
                                    </IconButton>
                                )}
                            </BSL_Common.SectionColumn>
                            {(!parent?.item || parent?.operation === "swap") && (
                                <Autocomplete
                                    items={autocompleteOptions}
                                    shouldItemRender={(item, value) =>
                                        item.toLowerCase().indexOf(value.toLowerCase()) > -1
                                    }
                                    getItemValue={(item) => item}
                                    autoHighlight={false}
                                    renderItem={(item, highlighted) => (
                                        <div
                                            key={item.id}
                                            style={{ backgroundColor: highlighted ? "#eee" : "transparent" }}
                                        >
                                            {item}
                                        </div>
                                    )}
                                    menuStyle={{
                                        zIndex: "999999",
                                        position: "absolute",
                                        backgroundColor: "whitesmoke",
                                        boxShadow: "1px 1px 4px",
                                        fontSize: "12px",
                                        left: "auto",
                                        top: "auto",
                                        marginLeft: "9px",
                                        marginTop: autoCompleteMarginTop,
                                        lineHeight: 1.4,
                                    }}
                                    inputProps={{
                                        style: {
                                            font: "200 12px Univers45",
                                            width: "95%",
                                            padding: "4px 0px 4px 8px !important",
                                        },
                                    }}
                                    renderInput={(props) => {
                                        return (
                                            <BSL_TextInput
                                                label="Code"
                                                value={ancillaryRow?.Code}
                                                tight
                                                allCaps
                                                style={{ flex: "none", width: "120px" }}
                                                onClick={(e) => {}}
                                                InputProps={{
                                                    style: { fontSize: "80%" },
                                                    ...props,
                                                }}
                                                helperText={
                                                    embed
                                                        ? null
                                                        : pricefileDescSummary?.[ancillaryRow?.Code]
                                                        ? pricefileDescSummary?.[ancillaryRow?.Code]
                                                        : "*Desc not found*"
                                                }
                                                tooltip={
                                                    !embed
                                                        ? null
                                                        : pricefileDescSummary?.[ancillaryRow?.Code]
                                                        ? pricefileDescSummary?.[ancillaryRow?.Code]
                                                        : "*Desc not found*"
                                                }
                                                onEnter={(e) =>
                                                    updateAncillaryData(
                                                        row_num,
                                                        "Code",
                                                        e.target.value.split("-")[0].trim()
                                                    )
                                                }
                                                onBlur={(value) =>
                                                    updateAncillaryData(row_num, "Code", value.split("-")[0].trim())
                                                }
                                            />
                                        );
                                    }}
                                    value={ancillaryRow?.Code}
                                    onChange={(e) =>
                                        updateAncillaryData(row_num, "Code", e.target.value.split("-")[0].trim())
                                    }
                                    onSelect={(value) =>
                                        updateAncillaryData(row_num, "Code", value.split("-")[0].trim())
                                    }
                                />
                            )}
                            <Autocomplete
                                items={
                                    mode === "FILTER"
                                        ? []
                                        : ["2", "4", "=((Area.NumInternalPurlins*3)+12)", "=NestedQty*2"]
                                }
                                autoHighlight={false}
                                getItemValue={(item) => item}
                                renderItem={(item, highlighted) => (
                                    <div
                                        key={item.id}
                                        style={{ backgroundColor: highlighted ? "#eee" : "transparent" }}
                                    >
                                        {item}
                                    </div>
                                )}
                                menuStyle={{
                                    zIndex: "999999",
                                    position: "absolute",
                                    backgroundColor: "whitesmoke",
                                    boxShadow: "1px 1px 4px",
                                    fontSize: "12px",
                                    left: "auto",
                                    top: "auto",
                                    marginLeft: "9px",
                                    marginTop: autoCompleteMarginTop,
                                    lineHeight: 1.4,
                                }}
                                inputProps={{
                                    style: {
                                        font: "200 12px Univers45",
                                        width: "95%",
                                        padding: "4px 0px 4px 8px !important",
                                    },
                                }}
                                renderInput={(props) => {
                                    return (
                                        <BSL_TextInput
                                            label="Qty"
                                            placeholder={mode === "FILTER" ? "Existing Qty" : "Parent Qty"}
                                            value={ancillaryRow?.Qty ? ancillaryRow?.Qty : ""}
                                            tight
                                            style={{ flex: "none", width: "220px" }}
                                            helperText={embed ? null : "number OR formula, start formula with '='"}
                                            tooltip={!embed ? null : "number OR formula, start formula with '='"}
                                            onClick={(e) => {}}
                                            InputProps={{
                                                style: { fontSize: "80%" },
                                                ...props,
                                            }}
                                            onEnter={(e) =>
                                                updateAncillaryData(
                                                    row_num,
                                                    "Qty",
                                                    e.target.value.replace("length", "Length").replace("qty", "Qty")
                                                )
                                            }
                                            onBlur={(value) =>
                                                updateAncillaryData(
                                                    row_num,
                                                    "Qty",
                                                    value.replace("length", "Length").replace("qty", "Qty")
                                                )
                                            }
                                        />
                                    );
                                }}
                                value={ancillaryRow?.Qty}
                                onChange={(e) =>
                                    updateAncillaryData(
                                        row_num,
                                        "Qty",
                                        e.target.value.replace("length", "Length").replace("qty", "Qty")
                                    )
                                }
                                onSelect={(value) =>
                                    updateAncillaryData(
                                        row_num,
                                        "Qty",
                                        value.replace("length", "Length").replace("qty", "Qty")
                                    )
                                }
                            />
                            <BSL_TextInput
                                label="Length"
                                placeholder={mode === "FILTER" ? "Existing Qty" : "Parent Length"}
                                value={ancillaryRow?.Length ? ancillaryRow?.Length : ""}
                                tight
                                style={{ flex: "none", width: "120px" }}
                                onClick={(e) => {}}
                                InputProps={{
                                    style: { fontSize: "80%" },
                                }}
                                onChange={(val) =>
                                    updateAncillaryData(row_num, "Length", val.replace("length", "Length"))
                                }
                                onBlur={(val) =>
                                    updateAncillaryData(row_num, "Length", val.replace("length", "Length"))
                                }
                            />

                            <BSL_TextInput
                                label="Use"
                                placeholder={mode === "FILTER" ? "" : row?.ProductIndex + " Part"}
                                value={ancillaryRow?.Use}
                                tight
                                style={{ flex: "none", width: "120px" }}
                                InputProps={{
                                    style: { fontSize: "80%" },
                                }}
                                onChange={(val) => updateAncillaryData(row_num, "Use", val)}
                                onBlur={(val) => updateAncillaryData(row_num, "Use", val)}
                            />

                            {mode !== "FILTER" && (
                                <Autocomplete
                                    items={[
                                        "Plain",
                                        "Area.RoofSheetColour",
                                        "Area.PostColour",
                                        "Area.BeamColour",
                                        "Area.RafterColour",
                                        "Area.PurlinColour",
                                        "Area.FasciaBeamColour",
                                        "Area.EdgeBeamColour",
                                        "Area.GutterColour",
                                        "Area.FlashingColour",
                                        "Area.RidgeColour",
                                    ]}
                                    shouldItemRender={(item, value) => true}
                                    autoHighlight={false}
                                    getItemValue={(item) => item}
                                    renderItem={(item, highlighted) => (
                                        <div
                                            key={item.id}
                                            style={{ backgroundColor: highlighted ? "#eee" : "transparent" }}
                                        >
                                            {item}
                                        </div>
                                    )}
                                    menuStyle={{
                                        zIndex: "999999",
                                        position: "absolute",
                                        backgroundColor: "whitesmoke",
                                        boxShadow: "1px 1px 4px",
                                        fontSize: "12px",
                                        left: "auto",
                                        top: "auto",
                                        marginLeft: "9px",
                                        marginTop: autoCompleteMarginTop,
                                        lineHeight: 1.4,
                                    }}
                                    inputProps={{
                                        style: {
                                            font: "200 12px Univers45",
                                            width: "95%",
                                            padding: "4px 0px 4px 8px !important",
                                        },
                                    }}
                                    renderInput={(props) => {
                                        return (
                                            <BSL_TextInput
                                                label="Colour"
                                                placeholder="Match Parent"
                                                value={ancillaryRow?.Colour ? ancillaryRow?.Colour : ""}
                                                tight
                                                style={{ flex: "none", width: "120px" }}
                                                helperText={embed ? null : "nominate colour OR match area"}
                                                tooltip={!embed ? null : "nominate colour OR match area"}
                                                InputProps={{
                                                    style: { fontSize: "80%" },
                                                    ...props,
                                                }}
                                                onEnter={(e) => updateAncillaryData(row_num, "Colour", e.target.value)}
                                                onBlur={(value) => updateAncillaryData(row_num, "Colour", value)}
                                            />
                                        );
                                    }}
                                    value={ancillaryRow?.Colour}
                                    onChange={(e) => updateAncillaryData(row_num, "Colour", e.target.value)}
                                    onSelect={(value) => updateAncillaryData(row_num, "Colour", value)}
                                />
                            )}
                        </React.Fragment>
                    )}
                    <BSL_ControlContainer
                        label={`Conditions... ${parent?.operation ? parent?.operation : "add"} this item IF ...`}
                        style={{ color: "white", display: "flex", flexDirection: "column" }}
                        tight={true}
                    >
                        {conditions_chips}
                        <Chip
                            label={
                                addNewCondition === row_num ? (
                                    <BSL_Common.SectionRow
                                        style={{
                                            alignItems: "center",
                                        }}
                                    >
                                        <span
                                            style={{
                                                fontSize: "12px",
                                                width: "40px",
                                                textAlign: "end",
                                            }}
                                        >
                                            {conditions_chips.length === 0 ? "" : "AND "}IF:
                                        </span>

                                        <BSL_Select
                                            value={newConditionKey}
                                            style={{ flex: "none", width: "180px" }}
                                            tight={true}
                                            items={[{ Key: "", Display: "[Condition]" }, ...condition_key_options]}
                                            onChange={(e) => {
                                                setNewConditionKey(e.target.value);
                                            }}
                                        />

                                        <BSL_Select
                                            value={newConditionOperator}
                                            style={{ flex: "none", width: "120px" }}
                                            tight={true}
                                            items={operator_options}
                                            onChange={(e) => {
                                                setNewConditionOperator(e.target.value);
                                            }}
                                        />
                                        {condition_key_options.find((kvp) => kvp.Key === newConditionKey)?.Options ? (
                                            <SegmentedButtonGroup
                                                style={{ width: "300px", flex: "none" }}
                                                value={newConditionValue}
                                                tight={true}
                                                items={
                                                    condition_key_options.find((kvp) => kvp.Key === newConditionKey)
                                                        ?.Options
                                                }
                                                onChange={(e, val) => {
                                                    appendNewCondition(row_num, val);
                                                    e.stopPropagation();
                                                }}
                                            />
                                        ) : (
                                            <BSL_TextInput
                                                value={newConditionValue}
                                                placeholder="new condition value"
                                                tight
                                                style={{ flex: "none", width: "160px" }}
                                                onEnter={(e) => appendNewCondition(row_num, e.target.value)}
                                                InputProps={{
                                                    style: { fontSize: "80%" },
                                                }}
                                                onBlur={(val) => setNewConditionValue(val)}
                                            />
                                        )}
                                    </BSL_Common.SectionRow>
                                ) : null
                            }
                            onDelete={() => {
                                if (addNewCondition === row_num) {
                                    appendNewCondition(row_num);
                                } else {
                                    setAddNewCondition(row_num);
                                }
                            }}
                            style={
                                addNewCondition === row_num
                                    ? { background: "#rgb(247 190 57)", width: "fit-content", height: "auto" }
                                    : { width: "55px", height: "auto", marginTop: "4px" }
                            }
                            deleteIcon={addNewCondition === row_num ? <DoneIcon /> : <AddIcon />}
                        />
                    </BSL_ControlContainer>
                </BSL_Common.SectionRow>
            );
        }
    }

    let title = "Edit Ancillary Items for " + row?.["ProductIndex"] + "-" + row?.["ProductDescription"];
    if (mode === "OFFERING" || mode === "FILTER") {
        title = "Edit Ancillary Items for " + offering_editcell?.title;
    }

    return (
        <OuterComponent {...outerProps}>
            {!embed && (
                <React.Fragment>
                    <textarea
                        id="w3review"
                        name="w3review"
                        style={{
                            backgroundColor: "beige",
                            fontFamily: "monospace",
                            padding: "10px",
                            borderRadius: "9px",
                            color: "#444444",
                            maxHeight: "400px",
                            overflowY: "auto",
                            fontSize: "12px",
                            width: "98%",
                        }}
                        rows="6"
                        onChange={(e) => {
                            setDisplayData(e.target.value);
                            if (checkValidJSON(e.target.value)) {
                                handleTextChange(JSON.parse("[" + e.target.value + "]"));
                            }
                        }}
                        onBlur={(e) => {
                            if (!checkValidJSON(e.target.value)) {
                                alert("JSON is not valid. Your changes may get saved...");
                                e.preventDefault();
                                return false;
                            } else {
                                handleTextChange(JSON.parse("[" + e.target.value + "]"));
                                setDisplayData(
                                    ReplaceAll(
                                        JSON.stringify("[" + e.target.value + "]")
                                            .substring(1)
                                            .slice(0, -1),
                                        "},",
                                        "},\n"
                                    )
                                );
                            }
                        }}
                        value={displayData}
                    />

                    <div
                        style={{
                            color: displayDataValidJSON ? "green" : "red",
                            fontSize: "12px",
                            padding: "10px",
                            textAlign: "center",
                        }}
                    >
                        {displayDataValidJSON ? "VALID JSON" : "NOT VALID JSON"}
                    </div>
                </React.Fragment>
            )}
            <div
                style={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    minHeight: embed ? "initial" : "600px",
                }}
            >
                {ancillary_rows}
                <BSL_Common.SectionRow style={{ position: "relative", width: "400px" }}>
                    <Autocomplete
                        items={autocompleteOptions}
                        shouldItemRender={(item, value) => {
                            if (!item.toLowerCase || !value.toLowerCase) return false;
                            return item.toLowerCase().indexOf(value.toLowerCase()) > -1;
                        }}
                        autoHighlight={false}
                        getItemValue={(item) => item}
                        renderItem={(item, highlighted) => (
                            <div key={item.id} style={{ backgroundColor: highlighted ? "#eee" : "transparent" }}>
                                {item}
                            </div>
                        )}
                        menuStyle={{
                            zIndex: "999999",
                            position: "absolute",
                            backgroundColor: "whitesmoke",
                            boxShadow: "1px 1px 4px",
                            fontSize: "12px",
                            left: "auto",
                            top: "auto",
                            marginLeft: "9px",
                            marginTop: autoCompleteItemMarginTop,
                            lineHeight: 1.4,
                            width: "100%",
                            maxHeight: "200px",
                            overflowY: "auto",
                        }}
                        inputProps={{
                            style: {
                                font: "200 12px Univers45",
                                width: "95%",
                                padding: "4px 0px 4px 8px !important",
                            },
                        }}
                        renderInput={(props) => {
                            if (!parent?.item) {
                                return (
                                    <BSL_TextInput
                                        label={embed && mode !== "FILTER" ? "New Ancillary Item Code" : "New Item Code"}
                                        value={newCode}
                                        tight
                                        allCaps
                                        placeholder={"New Item"}
                                        style={{ flex: "none", width: "200px" }}
                                        onClick={(e) => {}}
                                        InputProps={{
                                            style: { fontSize: "80%" },
                                            ...props,
                                        }}
                                        helperText={embed ? null : "*Select Item*"}
                                        onEnter={(e) =>
                                            updateAncillaryData(-1, "Code", e.target.value.split("-")[0].trim())
                                        }
                                    />
                                );
                            }
                        }}
                        value={newCode}
                        onChange={(e) => setNewCode(e.target.value.split("-")[0].trim())}
                        onSelect={(value) => updateAncillaryData(-1, "Code", value.split("-")[0].trim())}
                    />
                    {mode !== "FILTER" && (
                        <IconButton
                            aria-label="add"
                            size="small"
                            onClick={() => {
                                updateAncillaryData(-1, "Code", parent.item ? parent.item : newCode, parent);
                            }}
                        >
                            <AddIcon fontSize="inherit" />
                        </IconButton>
                    )}
                </BSL_Common.SectionRow>
            </div>
            {mode === "FILTER" && (
                <IconButton
                    aria-label="add"
                    size="small"
                    onClick={() => {
                        updateAncillaryData(-1, "Code", parent.item ? parent.item : newCode, parent);
                    }}
                >
                    <AddIcon fontSize="inherit" />
                </IconButton>
            )}
            <BSL_Dialog
                title={"Confirm Delete"}
                open={confirmDelete !== null}
                button1Text="Delete"
                button1Click={() => {
                    handleDeleteRow(confirmDelete);
                    setConfirmDelete(null);
                }}
                button2Text="Cancel"
                button2Click={() => {
                    setConfirmDelete(null);
                }}
            >
                Are you sure you want to delete ancillary row {confirmDelete + 1}?
            </BSL_Dialog>
        </OuterComponent>
    );
}
